import React from 'react'
import { Box, Button, FormLabel, Grid, MenuItem, Select, TextField } from '@mui/material'
import AutoCompleteComponent from './AutoCompleteComponent'
import DatePickerAccessCodeComponent from './DatePickerAccessCodeComponent'


const AccessCodeForm = ({
    toDate,
    fromDate,
    minDate,
    fromMaxDate,
    toMinDate,
    handleToDate,
    handleFromDate,
    handleFormData,
    selectedUser,
    setSelectedUser,
    toMaxDate,
    //userLevel,
    roleList,
    controllersList,
    controllerId,
    setControllerId
    //handleChangeLevelChange
}) => {
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Grid container spacing={6}>
                <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="file-select-label">Select User </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                    <AutoCompleteComponent
                        value={selectedUser}
                        onChange={setSelectedUser}
                    />
                </Grid>
                <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="file-select-label">Login </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                    <TextField 
                        fullWidth
                        disabled
                        value={selectedUser?.login ? selectedUser?.login : ''}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={6}>
                <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="file-select-label">Vaild From </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel> 
                    <DatePickerAccessCodeComponent 
                        value={fromDate} 
                        minDate={minDate} 
                        maxDate={fromMaxDate}
                        handleChange={handleFromDate} 
                    />
                    <span>The code becomes usable after this time</span>
                </Grid> 
                <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="file-select-label">Vaild To </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel> 
                    <DatePickerAccessCodeComponent 
                        value={toDate} 
                        minDate={toMinDate ? toMinDate : minDate} 
                        maxDate={toMaxDate ? toMaxDate : minDate}
                        handleChange={handleToDate} 
                    />
                    <span>The code becomes usable after this time</span>
                </Grid>
            </Grid>
            <Grid container spacing={6}>
                {/* <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="file-select-label">User ID</FormLabel>
                    <TextField 
                        fullWidth
                        disabled
                        value={selectedUser?.b2c_id ? selectedUser?.b2c_id : ''}
                    />
                </Grid> */}
                <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="demo-simple-select-standard-label">Select Level </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                    <Select
                        fullWidth
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        sx={{ "&:focus": {
                                backgroundColor: "#ffffff"
                                } 
                            }}
                        value={ selectedUser?.roleId ? selectedUser?.roleId.toString() : ''}
                        //onChange={(event) => handleChangeLevelChange(event)}
                        //error={userLevel === ""}
                        disabled    
                    >
                        <MenuItem value="">Select Level</MenuItem>     
                        { roleList?.data?.records?.filter(obj => obj.role_type === '2').map((role) => (
                            <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                        ))} 
                    </Select>
                </Grid> 

                <Grid item xs={12} sm={10} md={5}>
                    <FormLabel id="demo-simple-select-standard-label">Select Controller </FormLabel><FormLabel sx={{color:'red'}}>*</FormLabel>
                    <Select
                        fullWidth
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        sx={{ "&:focus": {
                                backgroundColor: "#ffffff"
                                } 
                            }}
                        value={ controllerId ? controllerId : ''}
                        onChange={(event) => setControllerId(event.target.value)}   
                    >
                        <MenuItem value="">Select Controller</MenuItem>
                        { controllersList?.data?.map((con) => (
                            <MenuItem key={con.id} value={con.id}>{con.controller_name}</MenuItem>
                        ))}    
                    </Select>
                    
                </Grid> 
            </Grid>

            
            <Grid item xs={12}> 
                <Button  
                    sx={{mr:1}}
                    variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleFormData}
                >Submit</Button>
                
            </Grid>
            <ul className='noteInfo'> 
                Note:
                <li><strong>Password Limit</strong>: You can generate up to 7 passwords at a time (one per day).</li>
                <li><strong>Date Limit</strong>: All selected dates must be within the next 30 days from today.</li>
            </ul>
        </Box>
    )
}

export default AccessCodeForm